<template>
  <div class="widget">
    <span class="widget__title">{{ title }}</span>
    <div class="widget__content">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
  export default defineNuxtComponent({
    name: 'WidgetWrapp',

    props: {
      title: {
        type: String,
        required: true,
      },
    },
  });
</script>

<style lang="scss" scoped>
  .widget {
    border: 1px solid $border-color--1;
    border-radius: 32px;
    min-width: 300px;
    max-width: 300px;
    overflow: hidden;
    font-family: $text-font--1;
    padding-bottom: $spacing-4;
    &__title {
      padding: $spacing-6 $spacing-6 $spacing-1;
      color: #000000;
      display: block;
      @include bigText;
      font-weight: 500;
    }
  }
</style>
